module.exports = __webpack_public_path__ + "img/prereveal.abcb13a9.png";